import { useState } from 'react';
import './Navigation.css';
import logo from '../../assets/images/rocaille-logo.png';

function Navigation({ onOpenShop }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [hoursOpen, setHoursOpen] = useState(false);

  const close = () => setMenuOpen(false);

  return (
    <nav className="nav">
      <div className="nav__inner">
        <div className="nav__links">
          <a href="#hero" className="nav__link">Home</a>
          <a href="#restaurant" className="nav__link">Über uns</a>
          <a href="#events" className="nav__link">Catering</a>
          <a href="#signature-cakes" className="nav__link">Signature Cakes</a>
          <button className="nav__link nav__link--btn" onClick={onOpenShop}>Shop</button>
        </div>

        <a href="#home" className="nav__logo">
          <img src={logo} alt="Rocaille" className="nav__logo-img" />
        </a>

        <div className="nav__actions">
          <div
            className={`nav__hours-wrap${hoursOpen ? ' nav__hours-wrap--open' : ''}`}
            onMouseEnter={() => setHoursOpen(true)}
            onMouseLeave={() => setHoursOpen(false)}
            onClick={() => setHoursOpen(!hoursOpen)}
          >
            <button className="nav__link nav__link--btn nav__hours-trigger">
              Öffnungszeiten
            </button>
            {hoursOpen && (
              <div className="nav__hours-dropdown">
                <p className="nav__hours-cat">Restaurant &amp; Bar</p>
                <div className="nav__hours-row">
                  <span>Mo – Sa</span><span>11:00 – 23:00</span>
                </div>
                <div className="nav__hours-row">
                  <span>So</span><span>geschlossen</span>
                </div>
                <p className="nav__hours-cat">Küche</p>
                <div className="nav__hours-row">
                  <span>Mo – Do</span><span>11:00 – 15:00 &amp; 17:00 – 22:00</span>
                </div>
                <div className="nav__hours-row">
                  <span>Fr – Sa</span><span>11:00 – 22:00</span>
                </div>
              </div>
            )}
          </div>

          <a href="tel:+4921197711737" className="nav__phone">
            <span className="nav__phone-icon">✆</span>
            +49 (0)211 97711737
          </a>
          <a href="mailto:genuss@rocaille.de" className="nav__action nav__action--reserve">Reservieren</a>
        </div>

        {/* Mobile hamburger */}
        <button
          className={`nav__burger${menuOpen ? ' nav__burger--open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menü"
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile menu overlay */}
      {menuOpen && (
        <div className="nav__mobile-menu">
          <a href="#hero" className="nav__mobile-link" onClick={close}>Home</a>
          <a href="#restaurant" className="nav__mobile-link" onClick={close}>Über uns</a>
          <a href="#events" className="nav__mobile-link" onClick={close}>Catering</a>
          <a href="#signature-cakes" className="nav__mobile-link" onClick={close}>Signature Cakes</a>
          <button className="nav__mobile-link nav__mobile-link--btn" onClick={() => { close(); onOpenShop(); }}>Shop</button>
          <div className="nav__mobile-divider" />
          <a href="tel:+4921197711737" className="nav__mobile-link">✆ +49 (0)211 97711737</a>
          <a href="mailto:genuss@rocaille.de" className="nav__mobile-link nav__mobile-link--gold" onClick={close}>Reservieren</a>
          <div className="nav__mobile-divider" />
          <div className="nav__mobile-hours">
            <p className="nav__mobile-hours-title">Öffnungszeiten</p>
            <div className="nav__mobile-hours-block">
              <p className="nav__hours-cat">Restaurant &amp; Bar</p>
              <div className="nav__hours-row"><span>Mo – Sa</span><span>11:00 – 23:00</span></div>
              <div className="nav__hours-row"><span>So</span><span>geschlossen</span></div>
              <p className="nav__hours-cat">Küche</p>
              <div className="nav__hours-row"><span>Mo – Do</span><span>11:00 – 15:00 &amp; 17:00 – 22:00</span></div>
              <div className="nav__hours-row"><span>Fr – Sa</span><span>11:00 – 22:00</span></div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navigation;
